import Facilities                       from "../../../domain/facility/Facilities";
import Facility                         from "../../../domain/facility/Facility";
import FacilityId                       from "../../../domain/facility/FacilityId";
import FacilityRepository               from "../../../domain/facility/FacilityRepository";
import FacilityWebReservationTargetType from "../../../domain/facility/FacilityWebReservationTargetType";
import {
  apiDeleteFacility,
  apiGetFacilities,
  apiGetFacility,
  apiPostFacility,
  apiPutFacility,
  apiPutFacilityTargetType
}                                       from "../../api/facility";

class FacilityDataSource implements FacilityRepository {
  readonly dispatch;

  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  async delete(facilityId: FacilityId): Promise<void> {
    return apiDeleteFacility(facilityId);
  }

  async findAll(): Promise<Facilities> {
    return apiGetFacilities();
  }

  async findBy(facilityId: FacilityId): Promise<Facility> {
    return apiGetFacility(facilityId);
  }

  async register(facility: Facility): Promise<void> {
    return apiPostFacility(facility);
  }

  async update(facility: Facility): Promise<void> {
    return apiPutFacility(facility);
  }

  async updateTargetType(facilityId: FacilityId, targetType: FacilityWebReservationTargetType): Promise<void> {
    return apiPutFacilityTargetType(facilityId, targetType);
  }

}

export default FacilityDataSource;
